/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { SiteFooter } from '@redturtle/iovisit-theme/components/layout';
/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = (props) => <SiteFooter {...props} />;

export default Footer;
